import AppLayout from "../layouts/AppLayout";

export default function Body() {
    return <AppLayout />;
}
